import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-reset-password',
  templateUrl: './reset-password.component.html',
  styleUrls: ['./reset-password.component.scss']
})
export class ResetPasswordComponent implements OnInit {

  ResetPasswordForm: any = FormGroup;
  submitted = false;
  loading = false;
  urlResetPassword = "api/users/resetPassword/:id";


  constructor(private formBuilder: FormBuilder, private httpclient: HttpClient) { }

  ngOnInit() {
    this.ResetPasswordForm = this.formBuilder.group({
      password: ['', [Validators.required, Validators.minLength(6)]]
    })
  }

  onSubmit() {
    this.submitted = true;
    let password = this.ResetPasswordForm.get("password").value;
    if (this.ResetPasswordForm.valid) {
      this.httpclient.post(this.urlResetPassword, password)
        .subscribe(data => {
          console.log(data);
          const resSTR = JSON.stringify(data);
          const resJSON = JSON.parse(resSTR);
          if (resJSON.status === 'ok') {
            Swal.fire(
              'Welcome !',
              resJSON.message,
              'success'
            )
          }
          else {
            Swal.fire({
              icon: 'error',
              title: 'Oops...',
              text: resJSON.message,
            });
          }
        })
    }
  }
  catch(e) {
    console.log("error reset password", e)
  }
}

